export const meta = {
  title: 'Terms of Service | gridcraft',
  description:
    'Terms for using gridcraft download resources, installation guides, Excel comparisons and usage reviews.',
  updated_at: '2026-10-18',
};

## About the service

gridcraft (gridcraft.me) provides GridCraft download resources, installation guidance, comparisons with Microsoft Excel, and usage experiences. By using the website, you agree to these terms and our [Acceptable Use Policy](/acceptable-use-policy). Our information practices are described in the [Privacy Policy](/privacy-policy).

## Independent resource and trademarks

This website is an independent resource. It is not the official website of ArtCraft or Microsoft and is not endorsed by either. GridCraft, ArtCraft, Microsoft and Excel names and marks belong to their respective owners. Naming a product helps identify the software being discussed.

## Downloads and installation

Download links may lead to third-party release pages. Before installing, check the publisher, software version, operating-system requirements and applicable license. The software publisher's license and terms govern use of that software. Our guides do not grant any additional software rights, paid licenses or technical support from the publisher.

Back up important files before installing software, importing workbooks or following troubleshooting steps. Do not disable security protections merely to follow a guide.

## Comparisons and usage experiences

Guides, comparisons and reviews reflect the versions, environments and test cases described in the relevant content. Features, pricing, compatibility and availability can change. A comparison is not a guarantee that a workbook, formula, macro or workflow will behave identically in another application. Test copies of your own files before changing a production workflow.

## Website tools and accounts

Any editor or demonstration provided on this website is offered as available. Save exported files and maintain your own backups. If you create an account, provide accurate information, protect your login details and report suspected unauthorized access. You remain responsible for the data you submit and must have permission to use it.

## Content and permitted use

You may read our content and share links for lawful purposes. Except where a license or applicable law allows otherwise, do not republish full articles, redistribute assets, or present our content as your own. Third-party software and source code remain subject to their respective licenses.

## Charges and third-party purchases

These terms do not establish a paid subscription, credit system or refund offer for this information website. Any future paid offer must disclose its price and purchase terms before payment. Purchases from third parties are governed by their own purchase, cancellation and refund terms.

## Availability and responsibility

We aim to provide useful, accurate information, but the website and its content are provided as available, without guarantees of completeness, uninterrupted access or suitability for a particular task. To the extent permitted by applicable law, we are not responsible for losses caused by reliance on guides, third-party downloads or file compatibility issues. These terms do not exclude rights or liabilities that applicable law does not allow to be excluded.

## Misuse and changes

We may restrict abusive access or remove unlawful content. We may also update content, links, features and these terms. The revision date appears above. Contact us if you believe a restriction or an article is incorrect.

## Contact

Website questions, corrections and support: [support@gridcraft.me](mailto:support@gridcraft.me).
